
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/ai-security",
      function () {
        return require("private-next-pages/solutions/ai-security.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/ai-security"])
      });
    }
  